import React from 'react';
export default function LoadingSpinner() {
    return (React.createElement("div", { className: "spinner-container" },
        React.createElement("div", { className: "spinner-container-loading" })));
}
